import { useQuery } from '@tanstack/react-query';
import { AuditLogsService } from '../services/audit-logs.service';
import type { AuditFilters } from '../types/audit-logs.types';
import { useState } from 'react';

export function useAuditLogs(companyId: string, initialFilters: AuditFilters = {}) {
  const [filters, setFilters] = useState<AuditFilters>({ page: 1, pageSize: 20, ...initialFilters });

  const query = useQuery({
    queryKey: ['audit-logs', companyId, filters],
    queryFn: () => AuditLogsService.getLogs(companyId, filters),
    enabled: !!companyId,
  });

  return {
    logs: query.data?.data || [],
    total: query.data?.total || 0,
    isLoading: query.isLoading,
    filters,
    setFilters,
    updatePage: (page: number) => setFilters(prev => ({ ...prev, page })),
    updatePageSize: (pageSize: number) => setFilters(prev => ({ ...prev, pageSize, page: 1 })),
  };
}

export function useAuditStats(companyId: string, startDate?: string, endDate?: string) {
  return useQuery({
    queryKey: ['audit-logs', 'stats', companyId, startDate, endDate],
    queryFn: () => AuditLogsService.getStats(companyId, { startDate, endDate }),
    enabled: !!companyId,
  });
}

export function useEntityTimeline(companyId: string, entityType: string, entityId: string) {
  return useQuery({
    queryKey: ['audit-logs', 'timeline', entityType, entityId],
    queryFn: () => AuditLogsService.getLogs(companyId, { entityType, entityId }),
    enabled: !!companyId && !!entityType && !!entityId,
  });
}
